/**
 * @author Christian Künne <christian.kuenne@tomtom.com>
 */

import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import FilterBarItem from './filter-bar-item'

import styles from './filter-bar-spacer.module.css'

const FilterBarSpacerPropTypes = {
    className: PropTypes.string
}

/**
 * Special filter bar spacer to fill-up space between <code>FilterBarItems</code> and to be used as child in a
 * <code><FilterBar/></code> component.
 *
 * @see FilterBar
 *
 * {@link https://confluence.tomtomgroup.com/display/TTB/Molecules#Molecules-FilterBar}
 *
 * @example
 * <FilterBar>
 *     <SearchField />
 *     <FilterBarSpacer />
 *     <Button>Refresh</Button>
 * </FilterBar>
 *
 * @param {Object} props - Component properties object
 * @param {string} [props.className] - A CSS class to append to the component
 * @returns {ReactElement}
 */
function FilterBarSpacer(props) {
    const composedClassName = cx(styles['filter-bar-spacer'], props.className)

    return <FilterBarItem className={composedClassName} />
}

FilterBarSpacer.propTypes = FilterBarSpacerPropTypes

export default FilterBarSpacer
